<template>
  <!-- 报告发布页 -->
  <div class="form-content-container" style="overflow: hidden">
    <Form
      class="form-container"
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      label-position="left"
    >
      <FormItem
        class="form-item"
        ref="FormItemTitle"
        prop="reportName"
        :rules="[
          { required: true, message: '标题不能为空', trigger: 'blur' },
          { validator: validatetitle, trigger: 'blur' },
        ]"
      >
        <div class="title titleRichEditor">
          <title-summary-editor
            v-if="titleFocus"
            bodyClass="chineseTitle"
            :id="'chineseTitle'"
            v-model.trim="formValidate.reportName"
            :initWithBold="true"
            initFontSize="36px"
            :minHeight="62"
            :placeholder="'请输入标题(5-50字)'"
            @changeValue="getTitle"
          ></title-summary-editor>
        </div>
        <div class="number">
          <span :class="wordCount > 50 ? 'fontColor' : ''">{{
            wordCount
          }}</span>
          / 50
        </div>
      </FormItem>
      <FormItem class="form-item" label="英文名称" prop="englishName">
        <Input
          placeholder="请输入英文名称"
          v-model="formValidate.englishName"
        />
      </FormItem>
      <FormItem class="form-item" label="封面" prop="cover">
        <PictureUpload
          @handleUpload="handleUpload"
          :cover="formValidate.cover"
        ></PictureUpload>
      </FormItem>
      <FormItem class="form-item" label="报告编号" prop="reportCode">
        <Input
          placeholder="请输入报告编号"
          v-model.trim="formValidate.reportCode"
        />
      </FormItem>
      <FormItem class="form-item" label="报告类型" prop="reportCharge">
        <RadioGroup v-model.trim="formValidate.reportCharge">
          <Radio label="付费"></Radio>
          <Radio label="免费"></Radio>
        </RadioGroup>
      </FormItem>
      <FormItem class="form-item" label="报告页码" prop="sizeNumber">
        <Input
          placeholder="请输入报告页码"
          type="number"
          v-model.trim="formValidate.sizeNumber"
        />
      </FormItem>
      <FormItem class="form-item" label="表格数量" prop="reportNumber">
        <Input
          placeholder="请输入表格数量"
          type="number"
          v-model.trim="formValidate.reportNumber"
        />
      </FormItem>
      <FormItem class="form-item" label="寄送方式" prop="sendWay">
        <Input
          placeholder="请输入寄送方式"
          v-model.trim="formValidate.sendWay"
        />
      </FormItem>
      <FormItem class="form-item" label="中文版全价">
        <Input
          placeholder="请输入中文版全价"
          type="number"
          v-model.trim="formValidate.chinesePrice"
        />
      </FormItem>
      <FormItem class="form-item" label="中文电子版价格">
        <Input
          placeholder="请输入中文电子版价格"
          type="number"
          v-model.trim="formValidate.electronicPrice"
        />
      </FormItem>
      <FormItem class="form-item" label="中文印刷版价格">
        <Input
          placeholder="请输入中文印刷版价格"
          type="number"
          v-model.trim="formValidate.printingPrice"
        />
      </FormItem>
      <FormItem class="form-item" label="英文版价格">
        <Input
          type="number"
          placeholder="请输入英文版全价"
          v-model.trim="formValidate.englishPrice"
        />
      </FormItem>
      <FormItem class="form-item" label="英文电子版价格">
        <Input
          type="number"
          placeholder="请输入英文电子版价格"
          v-model.trim="formValidate.electronicEnglishPrice"
        />
      </FormItem>
      <FormItem class="form-item" label="英文印刷版价格">
        <Input
          type="number"
          placeholder="请输入英文印刷版价格"
          v-model.trim="formValidate.printingEnglishPrice"
        />
      </FormItem>
      <FormItem class="form-item" label="内容介绍" prop="content">
        <Input
          placeholder="请输入内容介绍"
          v-model.trim="formValidate.content"
        />
      </FormItem>
      <FormItem
        class="form-item"
        label="目录"
        prop="catalogue"
        ref="FormItemCatalogue"
      >
        <Editor
          :id="'editor'"
          v-model="formValidate.catalogue"
          :placeholder="'请输入目录'"
        />
      </FormItem>
      <FormItem
        class="form-item"
        label="行业分类"
        :rules="{ required: true, trigger: 'change' }"
      >
        <FormItem prop="businessId1name">
          <Select
            style="width: 200px; margin-right: 10px"
            placeholder="请选择一级分类"
            v-model="formValidate.businessId1name"
          >
            <Option
              :value="v.name"
              v-for="v in oneList"
              :key="v.id"
              @click.native="handleSelect(v)"
              >{{ v.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem prop="businessId2name">
          <Select
            style="width: 200px"
            placeholder="请选择二级分类"
            v-model="formValidate.businessId2name"
          >
            <Option
              :value="v.name"
              v-for="v in twoList"
              :key="v.id"
              @click.native="handleSelect1(v)"
              >{{ v.name }}</Option
            >
          </Select>
        </FormItem>
      </FormItem>
      <FormItem
        class="form-item"
        label="附件"
        prop="accessoryName"
        ref="FormItemAccessoryName"
      >
        <FileUplode
          :fileName="formValidate.accessoryName"
          @isUpload="isUpload"
          @handlefileUpload="handlefileUpload"
        />
      </FormItem>
      <FormItem class="form-item" label="发布栏目">
        <!-- <Checkbox v-model="formValidate.synchronizedStatus"></Checkbox>
        <span>{{ columnNum }}</span> -->
        <Tree
          :data="treeList"
          show-checkbox
          @on-check-change="changeCheck"
        ></Tree>
      </FormItem>
      <div class="submit-container">
        <Button @click="preview" :disabled="isShow" v-throttleClick="2000"
          >预览</Button
        >
        <Button
          v-throttleClick="2000"
          :disabled="isUploadState || canClick"
          @click="handleSubmit(formValidate, 1)"
          >保存</Button
        >
        <Button
          v-throttleClick="2000"
          :disabled="isUploadState || canClick"
          @click="handleSubmit(formValidate, 0)"
          >发布</Button
        >
      </div>
    </Form>
    <AuthenticationModel
      v-if="isFlag"
      @handleClose="isFlag = false"
    ></AuthenticationModel>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PictureUpload from "../../components/PictureUpload.vue";
import FileUplode from "../../components/fileUplode.vue";
import AuthenticationModel from "../../components/AuthenticationModel.vue";
import Editor from "../../components/editor";
import TitleSummaryEditor from "@/views/PCView/user/components/TitleSummaryEditor";
import ruleUtils from "@/utils/ruleValidate.js";
export default {
  components: {
    PictureUpload,
    AuthenticationModel,
    FileUplode,
    Editor,
    TitleSummaryEditor,
  },
  created() {
    // 认证
    if (this.userInfo.user.customerType === 1) {
      this.isFlag = true;
    }
    this.getOneLists();
    this.projectAndColumnListByType({
      type: 3,
    });
    if (this.$route.query.id) {
      this.getEcho(this.formValidate);
      this.isShow = false;
    } else {
      setTimeout(() => {
        this.getTrees();
      }, 1000);
    }
  },
  mounted() {
    this.titleFocus = true;
  },
  data() {
    return {
      titleFocus: false,
      wordCount: 0,
      isShow: true,
      canClick: false,
      isUploadState: false,
      isFlag: false,
      oneList: [], // 一级行业列表
      twoList: [], // 二级行业列表
      tempArr: [],
      treeList: [], //发布栏目
      ismodify: 1,
      formValidate: {
        reportName: "",
        interest: [], // 栏目
        filePath: "", // 文件路径
        accessoryName: "", // 文件名称
        englishName: "",
        reportCode: "",
        reportCharge: 1,
        sizeNumber: "",
        reportNumber: "",
        sendWay: "",
        chinesePrice: "",
        electronicPrice: "",
        printingPrice: "",
        englishPrice: "",
        electronicEnglishPrice: "",
        printingEnglishPrice: "",
        content: "",
        catalogue: "",
        businessId1: "", //一级行业
        businessId2: "", //二级行业
        businessId1name: "", //一级行业名称
        businessId2name: "", //二级行业名称
        synchronizedStatus: false,
        cover: "",
      },
      ruleValidate: ruleUtils,
      previewData: {
        data: {
          articleId: this.$route.query.id ? this.$route.query.id : "",
          articleType: 6,
        },
      },
    };
  },
  computed: {
    ...mapState(["token", "userInfo"]),
    columnNum() {
      let str = "";
      if (sessionStorage.getItem("isSon") === "false") {
        if (this.userInfo.user.customerType === 4) {
          str = "百科号";
        } else if (this.userInfo.user.customerType === 5) {
          str = "机构号";
        } else if (
          this.userInfo.user.customerType === 1 ||
          this.userInfo.user.customerType === 2
        ) {
          str = "百家号";
        }
      } else {
        if (this.userInfo.user.subType === 1) {
          str = "百科号";
        } else if (this.userInfo.user.subType === 2) {
          str = "机构号";
        }
      }
      return str;
    },
  },
  watch: {
    "formValidate.reportName"() {
      this.$refs.FormItemTitle.$emit("on-form-change");
    },
    "formValidate.catalogue"() {
      this.$refs.FormItemCatalogue.$emit("on-form-change"); // 对非View组件触发表单校验change方法
    },
    "formValidate.accessoryName"() {
      this.$refs.FormItemAccessoryName.$emit("on-form-change"); // 对非View组件触发表单校验change方法
    },
  },
  methods: {
    getTitle(params) {
      /* params接收富文本对象，以JSON字符串方式传递，需解析为对象；
      解析后格式如{id: "englishTitle",value:{default: ""}} */
      params = JSON.parse(params);
      // 获取富文本输入框ID，用于区分
      var editorId = params.id;

      // params.value获取富文本输入框的值，有两种可能的值，默认为对象类型 value:{default: ""}；一旦有值，则变为字符串类型，如value: '<p style="line-height: 1.5;">&nbsp;'
      let originalText = params.value; // 获取富文本输入框原始值
      if (typeof originalText == "object") originalText = "";

      // 定义正则表达式reg 过滤标签（无法正常保留<>,如遇<某某决议>这种，还需修改正则）
      var reg = new RegExp("<[^<>]+>", "g");
      // 过滤后的字符串内容，用于统计字数
      let countText = originalText.replace(reg, "");

      // 现将特殊字符$nbsp;替换成空格然后将其他特殊字符匹配成1来便于计数
      var reg2 = /\&[0-9a-z]+;/g;
      countText = countText.replace(/&nbsp;/gi, "");
      if (countText.match(reg2) != null && countText.match(reg2).length != 0) {
        countText = countText.replace(reg2, "1");
      }
      // 将原值中的额$nbsp;替换为普通空格(html中的空格)
      originalText = originalText.replace(/&nbsp;/gi, "");

      // 不为空时，保留sub,sup标签，过滤其他标签
      originalText = originalText.replace(/(?!<(\/?sub|\/?sup).*?>)<.*?>/g, "");
      originalText = originalText.trim();
      // 去掉头尾空格以计数
      countText = countText.trim();

      this.formValidate.reportName = originalText;
      countText = this.filterSubSup(countText);
      this.wordCount = countText.length;
      this.$refs.FormItemTitle.$emit("on-form-change"); // 对非View组件触发表单校验change方法
    },
    // 过滤字符串中的sub/sup标签，返回过滤后的字符串。以计字数
    filterSubSup(s) {
      if (s.indexOf("<sub>") != -1 || s.indexOf("<sup>") != -1) {
        s = s.replace(/<sub>/gi, "");
        s = s.replace(/<\/sub>/gi, "");
        s = s.replace(/<sup>/gi, "");
        s = s.replace(/<\/sub>/gi, "");
      }
      return s;
    },
    validatetitle(rule, value, callback) {
      var reg = new RegExp("<[^<>]+>", "g");
      var s = value.replace(reg, "");
      var reg2 = /\&[0-9a-z]+;/g;

      if (s.match(reg2) != null && s.match(reg2).length != 0) {
        s = s.replace(reg2, " ");
      }
      if (s.length < 5 || s.length > 50) {
        return callback(new Error("标题限制5到50个字数"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },
    // 预览
    async preview() {
      const resp = await this.$apis.userServe.setPreview({
        ...this.previewData.data,
      });
      let URL = this.$router.resolve({
        path: "/reportpreview",
        query: {
          articleId: resp.data,
        },
      });
      window.open(URL.href, "_blank");
    },
    getIntroduction(vla) {
      this.formValidate.catalogue = vla;
    },
    getTrees() {
      this.treeList = this.treeList.map((item) => {
        return {
          title: item.projectName,
          expand: true,
          menuIds: item.projectId,
          checked: false,
          children:
            item.columns &&
            item.columns.map((v) => {
              return {
                title: v.columnName,
                menuIds: item.projectId,
                id: v.id,
                checked: false,
              };
            }),
        };
      });
    },
    // 回显
    async getEcho(f) {
      this.getTwoLists({
        parentId: this.formValidate.businessId1,
      });
      const resp = await this.$apis.userServe.getEcho({
        articleId: this.$route.query.id,
        articleType: 6,
      });
      this.getTrees();
      // 发布栏目
      resp.data.articlePushList.forEach((itemL) => {
        this.treeList.forEach((itemT) => {
          if (
            itemT.children &&
            itemT.children.length > 0 &&
            itemL.projectId !== undefined
          ) {
            itemT.children.forEach((itemC) => {
              if (itemC.id == itemL.channelId1) {
                itemC["checked"] = true;
              }
            });
          } else {
            if (itemT.menuIds == itemL.projectId) {
              itemT["checked"] = true;
            }
          }
        });
      });
      const r = resp.data.data;
      f.reportName = r.reportName;
      f.filePath = 1; // 文件路径
      f.accessoryName = r.accessoryName; // 文件名称
      f.cover = r.cover;
      f.englishName = r.englishName;
      f.reportCode = r.reportCode;
      f.reportCharge = r.reportCharge === 0 ? "付费" : "免费";
      f.sizeNumber = r.sizeNumber;
      f.reportNumber = r.reportNumber;
      f.sendWay = r.sendWay;
      f.chinesePrice = r.chinesePrice;
      f.electronicPrice = r.electronicPrice;
      f.printingPrice = r.printingPrice;
      f.englishPrice = r.englishPrice;
      f.electronicEnglishPrice = r.electronicEnglishPrice;
      f.printingEnglishPrice = r.printingEnglishPrice;
      f.content = r.content;
      f.catalogue = r.catalogue;
      f.businessId1 = r.businessId1 * 1;
      f.businessId2 = r.businessId2 * 1;
      f.businessId1name = r.businessId1name; //一级行业名称
      f.businessId2name = r.businessId2name; //二级行业名称
      f.synchronizedStatus = r.synchronizedStatus === 1 ? true : false;
      this.ismodify = r.auditStatus;
    },
    async handleSubmit(formValidate, status) {
      this.canClick = true;
      // 认证
      if (this.userInfo.user.customerType === 1) {
        this.isFlag = true;
        return;
      }
      this.$refs.formValidate.validate(async (valid) => {
        if (valid) {
          if (this.tempArr.length === 0) {
            this.treeList.forEach((item) => {
              if (item.children && item.children.length > 0) {
                item.children.forEach((v) => {
                  if (v.checked) {
                    this.tempArr.push(v);
                  }
                });
              } else {
                if (item.checked) {
                  this.tempArr.push(item);
                }
              }
            });
          }
          // 发布栏目
          let arr = [];
          this.tempArr.forEach((item) => {
            if (!(item.children && item.children.length > 0)) {
              arr.push({
                projectId: item.menuIds || null,
                channelId1: item.id || null,
              });
            } else {
              return;
            }
          });
          formValidate.interest = [...arr];
          const { data } = await this.$apis.userServe.webSave({
            auditStatus: status === 1 ? this.ismodify : 0,
            articleType: 6,
            reportName: formValidate.reportName,
            filePath: formValidate.filePath, // 文件路径
            accessoryName: formValidate.accessoryName, // 文件名称
            articlePushList: formValidate.interest,
            cover: formValidate.cover,
            englishName: formValidate.englishName,
            reportCode: formValidate.reportCode,
            reportCharge: formValidate.reportCharge === "付费" ? 0 : 1,
            sizeNumber: formValidate.sizeNumber,
            reportNumber: formValidate.reportNumber,
            sendWay: formValidate.sendWay,
            chinesePrice: formValidate.chinesePrice,
            electronicPrice: formValidate.electronicPrice,
            printingPrice: formValidate.printingPrice,
            englishPrice: formValidate.englishPrice,
            electronicEnglishPrice: formValidate.electronicEnglishPrice,
            printingEnglishPrice: formValidate.printingEnglishPrice,
            content: formValidate.content,
            catalogue: formValidate.catalogue,
            businessId1: formValidate.businessId1, //一级行业
            businessId2: formValidate.businessId2, //二级行业
            businessId1name: formValidate.businessId1name, //一级行业名称
            businessId2name: formValidate.businessId2name, //二级行业名称
            synchronizedStatus:
              formValidate.synchronizedStatus === true ? 1 : 0,
            articleId:
              this.$route.query.id || this.previewData.data.articleId || null,
          });
          if (data.resultCode !== "200") {
            this.canClick = false;
            this.$Message.error(data.resultDesc);
          } else {
            this.$Message.success(status === 1 ? "保存成功" : "发布成功");
            this.previewData = data;
            this.isShow = false;
            this.canClick = false;
            if (status === 1) return;
            this.$router.push("/user/contentMrg");
            // this.clearField(); // 清空
          }
        } else {
            this.canClick = false;
          this.$Message.error("填写错误,请检查后重新提交");
        }
      });
    },
    async getOneLists() {
      const resp = await this.$apis.userServe.getOneLists();
      this.oneList = resp.indOneList;
    },
    async getTwoLists(data) {
      const resp = await this.$apis.userServe.getTwoLists(data);
      this.twoList = resp.indOtherList;
    },
    handleSelect(e) {
      this.getTwoLists({
        parentId: e.id,
      });
      this.formValidate.businessId1 = e.id;
      this.formValidate.businessId1name = e.name;
    },
    handleSelect1(e) {
      this.formValidate.businessId2 = e.id;
      this.formValidate.businessId2name = e.name;
    },
    isUpload(state) {
      this.isUploadState = state;
    },
    handlefileUpload(url, name) {
      this.formValidate.filePath = url;
      this.formValidate.accessoryName = name;
    },
    handleUpload(url) {
      this.formValidate.cover = url; // 图片路径
    },
    // 发布栏目
    async projectAndColumnListByType(data) {
      const resp = await this.$apis.userServe.projectAndColumnListByType(data);
      this.treeList = [...resp.data[0]];
    },
    changeCheck(item) {
      this.tempArr = item;
    },
    clearField() {
      // 清空
      this.formValidate.reportName = "";
      this.formValidate.interest = []; // 栏目
      this.formValidate.filePath = ""; // 文件路径
      this.formValidate.accessoryName = ""; // 文件名称
      this.formValidate.englishName = "";
      this.formValidate.reportCode = "";
      this.formValidate.reportCharge = 1;
      this.formValidate.sizeNumber = "";
      this.formValidate.reportNumber = "";
      this.formValidate.sendWay = "";
      this.formValidate.chinesePrice = "";
      this.formValidate.electronicPrice = "";
      this.formValidate.printingPrice = "";
      this.formValidate.englishPrice = "";
      this.formValidate.electronicEnglishPrice = "";
      this.formValidate.printingEnglishPrice = "";
      this.formValidate.content = "";
      this.formValidate.catalogue = "";
      this.formValidate.synchronizedStatus = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#text-container ::v-deep table {
  th,
  td {
    width: 200px;
    height: 35px;
    vertical-align: top;
    word-break: break-all;
  }
}
::v-deep #text-container .placeholder {
  color: #999;
}
::v-deep #text-container .w-e-text-container {
  z-index: 1 !important;
}
::v-deep #toolbar-container .w-e-toolbar {
  justify-content: center;
  z-index: 2 !important;
}
::v-deep #toolbar-container {
  margin-top: 17px;
  width: 101%;
}
::v-deep #text-container {
  width: 100%;
  min-height: 300px;
  border: none;
  outline: none;
  color: #515a6e;
}
::v-deep .ivu-tree ul li {
  margin: 0;
}
::v-deep .ivu-tree-children li {
  display: flex;
}
::v-deep .ivu-tree-children li .ivu-tree-arrow {
  display: none;
}
::v-deep .ivu-tree-children li .ivu-tree-children li {
  margin: 30px 40px 0 -60px;
}

::v-deep .ivu-tree-title:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-title-selected,
.ivu-tree-title-selected:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-children li .ivu-tree-title {
  width: 100px;
}
::v-deep .ivu-radio-group {
  white-space: nowrap;
}
.ivu-input-wrapper ::v-deep input {
  border: none;
  background-color: #fff;
  height: 38px;
}
.ivu-input-wrapper ::v-deep input::-webkit-input-placeholder,
.ivu-input-wrapper ::v-deep textarea::-webkit-input-placeholder {
  color: #999;
}
.ivu-upload ::v-deep .ivu-upload-drag {
  border: none;
  display: flex;
  align-items: center;
}
::v-deep .ivu-upload {
  // height: 38px;
  display: flex;
  align-items: center;
}
.ivu-input-wrapper ::v-deep textarea {
  border: none;
}
.form-container {
  margin: 0 auto 100px;
  padding: 60px 100px 0;
  width: 1200px;
  background-color: #fff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  .form-item {
    padding-bottom: 25px;
    width: 100%;
    color: #999;
    &::v-deep .ivu-form-item-label {
      min-width: 110px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }

    &::v-deep .titleRichEditor {
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
      align-items: flex-end;
      .titleInput {
        flex: 1;
        margin-right: 0px;
      }
    }

    // 标题
    ::v-deep .title {
      flex: 1;
      display: flex;
      align-items: flex-end;
      width: 100%;
      height: 100%;
      // line-height: 38px;
      // padding-top: 14px;
      position: relative;
      #titleEditor {
        font: 400 36px "Microsoft Yahei";
        color: #515a6e;
        width: calc(100% - 60px) !important;
        margin-right: 10px;
      }
      .titleInput {
        flex: 1;
        margin-right: 10px;
      }

      &::v-deep .ivu-input-type-textarea {
        textarea {
          font-size: 36px;
          resize: none;
        }
      }
    }
    &::v-deep .ivu-form-item-content {
      display: flex;
      // align-items: center;
    }
    &:not(:last-child) {
      border-bottom: 1px solid #dcdcdc;
    }
    .left,
    .right {
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    .left {
      border-right: 1px solid #dcdcdc;
      width: 355px;
    }
    .right {
      margin-left: 10px;
      width: 642px;
    }
    .year,
    .center,
    .stage {
      display: flex;
      align-items: center;
    }
    .year {
      width: 299px;
      border-right: 1px solid #dcdcdc;
    }
    .center {
      width: 323px;
      border-right: 1px solid #dcdcdc;
    }
    .stage {
      width: 374px;
    }
  }
  .title-item {
    align-items: end;
  }
}
.submit-container {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 80px;
  height: 70px;
  background-color: #fff;
  text-align: center;
  line-height: 70px;
  button {
    margin: 0 10px;
  }
}
</style>
